import React from "react";
import preview from "../assets/images/loginRentara.png"

function HeroBanner() {
    return (
        <section id="home" style={{ paddingBottom: "10rem" }}>
            <div className="container">
                <div className="home-text">
                    <div className="section-text__title-big">
                        Simplify Your Rental Management with Rentara
                    </div>
                    <div className="section-text__body" style={{ color: "white" }}>
                        Welcome to Rentara, the all-in-one rental management app designed to make your life as a landlord or property manager easier. Whether you own residential properties,
                        commercial spaces, or both, Rentara simplifies the way you handle rent collection, tenant communication, and property administration.
                    </div>
                    <a href="#download" className="download-btn">
                        Download App
                    </a>
                </div>

                <div className="section-image">
                    <img src={preview} alt="app preview" />
                </div>
            </div>
        </section>
    );
}

export default HeroBanner;
